import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import {
  hubFilterFormControlLabelSlotProps,
  hubFilterFormControlLabelSx,
} from '../common/tableMuiStyles';
import {
  settingsToggleHelperSx,
  settingsToggleLabelSx,
} from './settingsMuiStyles';

export type ToggleSettingProps = {
  id: string;
  label: string;
  helper?: string;
  value: boolean;
  disabled?: boolean;
  /** Compact toolbar styling — matches hub filter checkboxes (Master, My games). */
  variant?: 'settings' | 'hub';
  labelSx?: SystemStyleObject<Theme>;
  onChange: (value: boolean) => void;
};

const ToggleSetting = ({
  id,
  label,
  helper,
  value,
  disabled,
  variant = 'settings',
  labelSx,
  onChange,
}: ToggleSettingProps) => {
  const isHub = variant === 'hub';
  const hubLabelSx = labelSx ?? undefined;

  return (
    <FormControl fullWidth={!isHub} disabled={disabled} component="fieldset">
      <FormControlLabel
        slotProps={
          isHub
            ? hubLabelSx
              ? {
                  typography: {
                    variant: 'inherit' as const,
                    sx: hubLabelSx,
                  },
                }
              : hubFilterFormControlLabelSlotProps
            : undefined
        }
        control={
          <Switch
            id={id}
            size={isHub ? 'small' : 'medium'}
            checked={value}
            onChange={(event) => onChange(event.target.checked)}
          />
        }
        label={label}
        sx={[
          isHub ? hubFilterFormControlLabelSx : null,
          isHub && hubLabelSx
            ? { '& .MuiFormControlLabel-label': hubLabelSx }
            : null,
          !isHub
            ? {
                '& .MuiFormControlLabel-label': {
                  ...settingsToggleLabelSx,
                  ...labelSx,
                },
                '& .MuiSwitch-root': {
                  transform: { xxl: 'scale(1.08)', xxxl: 'scale(1.15)' },
                },
              }
            : null,
        ]}
      />
      {helper ? (
        <FormHelperText sx={settingsToggleHelperSx}>{helper}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default ToggleSetting;
